<template>
	<select class="cs-select" :value="value">
		<slot></slot>
	</select>
</template>

<script>
    export default {
 		props:["value", "bookSection"],

		data: function() {
            return {
				book_sections: this.bookSection,
            }
        },
        mounted(){
	    	$(this.$el)
	      	.chosen()
	      	.on("change", () => this.$emit('input', $(this.$el).val()))
	  	},
	  	watch:{
	  		value(val){
	  			$(this.$el).val(val).trigger('chosen:updated');
	  		}
	  	},
	  	destroyed() {
	  		$(this.$el).chosen('destroy');
		},
		methods : {
			update(list) {
				this.book_sections = list;
				this.$nextTick(function() {
					$(this.$el).trigger('chosen:updated');
					$(this.$el).trigger('change');
                });
			}
		}
    }
</script>